import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  useColorModeValue as mode,
} from '@chakra-ui/react';
import React from 'react';
import { useFormState } from 'react-hook-form';

import PhoneInput from 'core/components/PhoneInput';

export const PhoneInputField = React.forwardRef((props, ref) => {
  const { onChange, field = {}, inputProps, control, defaultValue, defaultCountry = 'GB' } = props;

  const { errors } = useFormState({
    control,
    name: field.name,
    ...field,
    disabled: false,
  });

  return (
    <FormControl position="relative" isInvalid={errors[field.name] !== undefined}>
      {field.label && (
        <FormLabel
          _focus={{ color: mode('blue.600', 'blue.300') }}
          position="absolute"
          fontSize={14}
          fontWeight="normal"
          color={mode('gray.500', 'white')}
          top="-3"
          ml={0}
          insetStart="2"
          bg={{ base: mode('white', 'gray.800'), md: mode('white', 'gray.700') }}
          zIndex={2}
          px="2"
        >
          {field.label}
          {field.required && ' *'}
        </FormLabel>
      )}
      <PhoneInput
        ref={ref}
        onChange={onChange}
        inputProps={inputProps}
        field={field}
        defaultValue={defaultValue}
        defaultCountry={defaultCountry}
      />
      {errors?.[field.name]?.type === 'required' && (
        <FormErrorMessage>
          {global?.constants?.translations?.errors?.required || 'This field is required'}
        </FormErrorMessage>
      )}
    </FormControl>
  );
});

export default React.memo(PhoneInputField);
